import { AppViewIds } from './appViewIds';

/**
 * Pages with separate view + admin AppView grants.
 * Admin columns are grouped under the parent in the permission matrix.
 */
export const PAGE_ACTION_GROUPS = [
    { parentId: AppViewIds.Plans, adminId: AppViewIds.PlansAdmin },
    { parentId: AppViewIds.PlanInbox, adminId: AppViewIds.PlanInboxAdmin },
];

const adminIdSet = new Set(PAGE_ACTION_GROUPS.map((group) => group.adminId.toLowerCase()));
const adminByParentId = new Map(
    PAGE_ACTION_GROUPS.map((group) => [group.parentId.toLowerCase(), group.adminId.toLowerCase()])
);
const parentByAdminId = new Map(
    PAGE_ACTION_GROUPS.map((group) => [group.adminId.toLowerCase(), group.parentId.toLowerCase()])
);

export function isPageActionAdminAppViewId(appViewId) {
    return appViewId ? adminIdSet.has(appViewId.toLowerCase()) : false;
}

export function getPageActionAdminId(parentId) {
    return adminByParentId.get(parentId?.toLowerCase()) ?? null;
}

export function getPageActionParentId(adminId) {
    return parentByAdminId.get(adminId?.toLowerCase()) ?? null;
}

function normalizeViewId(view) {
    return (view?.id ?? '').toLowerCase();
}

function findViewById(views, appViewId) {
    const normalizedId = appViewId?.toLowerCase();
    return views.find((view) => normalizeViewId(view) === normalizedId) ?? null;
}

/**
 * Build matrix column descriptors for a nav group tab.
 * @returns {Array<{ type: 'single', view } | { type: 'pageActions', parent, admin }>}
 */
export function buildMatrixColumns(views) {
    const columns = [];

    for (const view of views) {
        const viewId = normalizeViewId(view);
        if (isPageActionAdminAppViewId(viewId)) {
            continue;
        }

        const adminId = getPageActionAdminId(viewId);
        if (adminId) {
            const adminView = findViewById(views, adminId);
            if (adminView) {
                columns.push({ type: 'pageActions', parent: view, admin: adminView });
                continue;
            }
        }

        columns.push({ type: 'single', view });
    }

    return columns;
}
